/* Build numbered pagination pills + "x-y of z" summary from the
   data attributes already present on the .gh-pagination nav. */
(function () {
    const nav = document.querySelector('.gh-pagination');
    if (!nav) return;

    const page = parseInt(nav.dataset.page, 10) || 1;
    const pages = parseInt(nav.dataset.pages, 10) || 1;
    const total = parseInt(nav.dataset.total, 10) || 0;
    const perPage = parseInt(nav.dataset.perPage, 10) || 10;

    const numbersEl = nav.querySelector('.js-pagination-numbers');
    const summaryEl = nav.querySelector('.js-pagination-summary');

    function urlForPage(n) {
        const base = window.location.pathname.replace(/\/page\/\d+\/?$/, '/');
        if (n <= 1) return base;
        return base.replace(/\/?$/, '/') + 'page/' + n + '/';
    }

    function addItem(n, isCurrent) {
        const el = isCurrent ? document.createElement('span') : document.createElement('a');
        el.textContent = String(n);
        el.className = 'gh-pagination-number' + (isCurrent ? ' is-current' : '');
        if (!isCurrent) el.href = urlForPage(n);
        numbersEl.appendChild(el);
    }

    function addEllipsis() {
        const el = document.createElement('span');
        el.className = 'gh-pagination-ellipsis';
        el.textContent = '…';
        numbersEl.appendChild(el);
    }

    if (numbersEl) {
        const windowSize = 1;
        const shown = new Set([1, pages]);
        for (let i = page - windowSize; i <= page + windowSize; i++) {
            if (i >= 1 && i <= pages) shown.add(i);
        }
        const sorted = Array.from(shown).sort((a, b) => a - b);

        let prev = 0;
        sorted.forEach(function (n) {
            if (prev && n - prev > 1) addEllipsis();
            addItem(n, n === page);
            prev = n;
        });
    }

    if (summaryEl && total > 0) {
        const start = (page - 1) * perPage + 1;
        const end = Math.min(page * perPage, total);
        summaryEl.textContent = start + '-' + end + ' of ' + total;
    }
})();
